module.exports = __webpack_public_path__ + "static/media/Eritrea - ER.595e2a42.png";